import { defineMessages } from 'react-intl';

export const scope = 'app.component.base.textbox';

export default defineMessages({
  required_indicator: {
    id: `${scope}.required_indicator`,
    defaultMessage: '*',
  },
});
